import { Instagram, Mail, MapPin, ArrowUpRight, Facebook } from "lucide-react";
import { CONTACT } from "../../data";

export default function Footer() {
  return (
    <footer className="relative bg-ink text-white overflow-hidden grain" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-20 md:py-28 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 border-b border-white/15 pb-16">
          <div className="lg:col-span-6">
            <h2 className="font-display font-extrabold tracking-tight text-4xl md:text-6xl leading-[1.02]">
              Vamos deixar<br />tudo <span className="font-serif-ed italic font-medium text-accent">cristalino?</span>
            </h2>
            <a href="#marcacao" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-ink font-semibold px-7 h-14 hover:bg-accent transition-colors" data-testid="footer-book-btn">
              Fazer marcação <ArrowUpRight size={18} />
            </a>
          </div>
          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-8">
            <div className="flex flex-col gap-8">
              <div>
                <p className="text-xs tracking-[0.2em] uppercase text-white/50 mb-3">Contactos</p>
                <a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors break-all"><Mail size={16} className="shrink-0" /> {CONTACT.email}</a>
              </div>
              <div>
                <p className="text-xs tracking-[0.2em] uppercase text-white/50 mb-3">Local</p>
                <p className="inline-flex items-center gap-2 text-white/80"><MapPin size={16} className="shrink-0" /> {CONTACT.city}</p>
              </div>
            </div>
            <div>
              <p className="text-xs tracking-[0.2em] uppercase text-white/50 mb-3">Redes</p>
              <div className="flex flex-col gap-3">
                <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors"><Instagram size={16} className="shrink-0" /> {CONTACT.instagramHandle}</a>
                <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors"><Facebook size={16} className="shrink-0" /> {CONTACT.facebookHandle}</a>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-4 pt-8 text-sm text-white/50">
          <p className="font-display font-bold text-white">{CONTACT.brand}<span className="text-accent">.</span></p>
          <p>© {new Date().getFullYear()} {CONTACT.brand}. Todos os direitos reservados.</p>
        </div>
      </div>
      <div className="hidden md:block pointer-events-none absolute -left-32 bottom-0 h-[400px] w-[400px] rounded-full bg-royal/30 blur-[70px]" />
    </footer>
  );
}
